// src/Utils/AuthRedirect.js
import { Navigate } from "react-router-dom";

function AuthRedirect({ children }) {
  const userId = localStorage.getItem('userId');
  const projectId = localStorage.getItem('projectId');
  const requiresPasswordChange = localStorage.getItem("requiresPasswordChange") === "true";

  // ✅ If authenticated, redirect to dashboard
  if (userId && requiresPasswordChange) {
    return <Navigate to="/change-password" replace />;
  }

  if (userId && projectId) {
    return <Navigate to="/dashboard" replace />;
  }

  // 🔓 If not authenticated, allow access to the login page
  return children;
}

export default AuthRedirect;
